import _module from 'module.js'

_module.directive('uniqueMacAddress', function (Hardware, $q) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, $input, attrs, ngModelCtrl) {
      var hardwareApi = new Hardware(null),
        originalValue = scope.$eval(attrs.ngModel)

      ngModelCtrl.$asyncValidators.uniqueMacAddress = (model, view) => {
        var value = model || view
        var dfd = $q.defer()

        if (!value || value.length === 0) {
          dfd.resolve(true)
        }

        if (!originalValue || originalValue !== value) {
          if (value) {
            let potential = value.replace(/[:\.-]/g, '')
            hardwareApi.getListResult({ q: potential }).then(
              data => {
                if (data.items.length === 0) {
                  dfd.resolve(true)
                } else {
                  dfd.reject('exists')
                }
              },
              err => {
                $q.reject(err)
              }
            )
          }
        } else {
          dfd.resolve(true)
        }
        return dfd.promise
      }
    }
  }
})
